import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { AgentsSelect } from 'fable/agentsSelect';
import { withSelection } from 'hocs';
import { useNotifications } from 'hooks/useNotifications';
import styles from './agentsAddModal.module.scss';
const AgentsAddModalImpl = (props) => {
    const notify = useNotifications();
    const handleSubmit = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        const { selection: { selectedItems }, addAgents, parentEntity, } = props;
        analytics.addAgentsModalFormSubmitted({
            addTo: parentEntity,
            selectedAgents: selectedItems.map((item) => {
                var _a, _b;
                return ({
                    id: item.id,
                    name: (_b = (_a = item.name) !== null && _a !== void 0 ? _a : item.display_name) !== null && _b !== void 0 ? _b : `${item.given_name} ${item.family_name}`,
                });
            }),
        });
        if (!selectedItems.length) {
            return;
        }
        addAgents(selectedItems.map((value) => value.id))
            .then(() => {
            const notificationOptions = {
                title: `Agent(s) added to ${parentEntity}`,
                text: `${selectedItems.length} agent(s) has been added to the ${parentEntity}`,
                icon: 'i-done',
                className: 'success',
                time: 5000,
            };
            notify(notificationOptions);
            handleClose();
        })
            .catch((e) => {
            const notificationOptions = {
                title: 'An error occurred',
                text: `An error occurred when trying to add agent(s) to the ${parentEntity}`,
                icon: 'i-exclamation',
                className: 'danger',
            };
            notify(notificationOptions);
            throw new Error(`Failed to add agent(s) to ${parentEntity}`);
        });
    };
    const handleClose = (canceled = false) => {
        const { selection, onClose } = props;
        selection.setSelectedItems([]);
        onClose(canceled);
    };
    const { isOpen, selection, parentEntity, teamId, queueId } = props;
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: () => handleClose(true) }, { children: [_jsx(ModalHead, { title: `Add agent(s) to ${parentEntity}`, onClose: () => handleClose(true) }), _jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(ModalBody, Object.assign({ className: styles.addAgentsModalBody }, { children: _jsx(AgentsSelect, { selectedItems: selection.selectedItems, selectAgent: selection.selectItem, deselectAgent: selection.deselectItem, teamId: teamId, queueId: queueId }) })), _jsx(ModalFoot, { cancelOnClick: () => handleClose(true), cancelName: "Cancel", confirmOnClick: handleSubmit, confirmName: "Add agent(s)", confirmProps: {
                            disabled: !selection.selectedItems.length,
                        } })] }))] })));
};
export const AgentsAddModal = withSelection(AgentsAddModalImpl);
